import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* addUpdateCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CATEGORIES.ADD_UPDATE_CATEGORY, action.payload, true);
}

export function* deleteCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CATEGORIES.DELETE_CATEGORY, action.payload, true);
}

export function* searchCategory(action: any): any {
    const yieldPuts = [{ type: ACTIONS.CATEGORIES.SEARCH_CATEGORY, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.CATEGORIES.SEARCH_CATEGORY, action.payload, true, yieldPuts);
}
// export function* searchCategory(action: any): any {
//     try {
//         const data = action.payload;
//         const resp = yield call(CallApi.GET, APIS.CATEGORIES.SEARCH_CATEGORY, data, true);
//         if (resp.status >= 200 && resp.status < 300 && resp.data) {
//             action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
//         } else {
//             action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
//         }
//     } catch (e: any) {
//         action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
//     }
// }

export function* categoryDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CATEGORIES.CATEGORY_DETAILS + action.payload, null, true);
}

export function* rearrangeCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CATEGORIES.REARRANGE_CATEGORY, action.payload, true);
}
